var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavicone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 167 239.9",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f5bfe;\n      }\n\n      .cls-2 {\n        fill: #6851ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.5,0C37.38,0,0,37.38,0,83.5s37.38,83.5,83.5,83.5,83.5-37.38,83.5-83.5S129.62,0,83.5,0ZM83.5,119c-19.61,0-35.5-15.89-35.5-35.5s15.89-35.5,35.5-35.5,35.5,15.89,35.5,35.5-15.89,35.5-35.5,35.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124,190l20,42h0c-26.37,10.59-94.62,10.47-121,0h0l20-42,.08-.03c26.38,7.85,54.47,7.85,80.85,0l.08.03Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 83,
    width: 84,
    height: 48
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicone);
export default __webpack_public_path__ + "static/media/favicone.266f8a79dab49c75aecddd08ba3c5e4b.svg";
export { ForwardRef as ReactComponent };